import React from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import useStyles from './styles'

const CategoryCard = ({ category, portalToken }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleSeeMore = (event) => {
    event.stopPropagation()
    history.push(`/training/${portalToken}/categories/${category.id}`)
  }

  return (
    <Box className={classes.card}>
      <Typography className={classes.label}>{category.name}</Typography>
      <Box className={classes.seeMoreBox}>
        <Button
          size="small"
          className={classes.seeMoreButton}
          onClick={handleSeeMore}
        >
          Ver mais
        </Button>
      </Box>
    </Box>
  )
}

export default CategoryCard
